import { GroupItem } from "./group-item";
import { Input, Component } from "@angular/core";
import { DossierTreeComponent } from "./dossier-tree.component";
import { TreeItem } from "./item";


@Component({
  selector: 't-dossier-tree-item',
  templateUrl: './dossier-tree-item.component.html',
})
export class DossierTreeItemComponent {
  @Input() item: TreeItem
  @Input() treeComponent: DossierTreeComponent

  toggle() {
    this.item.closed = !this.item.closed;

    return false;
  }

  onAdd() {
    this.treeComponent.added.emit(this.item);

    return false;
  }

  onSelect() {
    this.treeComponent.selected.emit(this.item);

    return false;
  }

  onDelete() {
    this.treeComponent.deleted.emit(this.item);

    return false;
  }

  onAddGroup() {
    this.treeComponent.groupAdded.emit(this.item);
    return false;
  }

  onDuplicateGroup() {
    this.treeComponent.groupDuplicated.emit(this.item);
    return false;
  }

  onDeleteGroup() {
    this.treeComponent.groupDeleted.emit(this.item);
    return false;
  }

  private emitGroupMoved(delta: number) {
    let groupItem = this.item as GroupItem;

    this.treeComponent.groupMoved.emit({
      item: groupItem,
      newOrder: groupItem.group.order + delta
    });
  }

  onMoveGroupUp() {
    this.emitGroupMoved(1);

    return false;
  }

  onMoveGroupDown() {
    this.emitGroupMoved(-1);

    return false;
  }

  toggleExpand() {
    this.item.toggleExpand();

    return false;
  }
}